import React, { Component } from 'react';
import apiRequest from '../../helpers/apiRequest';
import * as endpoints from '../../helpers/endpoints';

class EventInfo extends Component {
    constructor() {
        super();

        this.state = {
            data: []
        };
    }
    componentDidMount() {
        apiRequest(
            `${endpoints.FETCH_SEARCH_PATH}${this.props.match.params.id}`,
            this.props.jwtToken
        )
            .then(payload => {
                this.setState({ data: payload.data });
            })
            .catch(error => {
                console.log(error);
                console.log('=====================');
            });
    }

    render() {
        return (
            <div className="profile">
                <pre>{JSON.stringify(this.state.data, null, '\t')}</pre>
            </div>
        );
    }
}

export default EventInfo;



// WEBPACK FOOTER //
// ./src/components/eventInfo/index.js